export default __webpack_public_path__ + "static/media/anadir-2.3dfafcc6.png";